import { render, staticRenderFns } from "./ExtendOtherNutrientsIron.vue?vue&type=template&id=35c5247a&scoped=true"
import script from "./ExtendOtherNutrientsIron.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsIron.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsIron.vue?vue&type=style&index=0&id=35c5247a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5247a",
  null
  
)

export default component.exports